import React from "react";
import { FaStar } from "react-icons/fa";
import "../css/FloatingStar.css";

const FloatingStar = () => {
  return (
    <a href="/products/5#showcase" className="floating-star">
      <div className="star-circle">
        <FaStar className="star-icon" />
      </div>
      <span className="star-text">View Product Showcase</span>
    </a>
  );
};

export default FloatingStar;
